<template>
    <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <div class="margintop-32" />
    <div class="in-row">
      <div class="background-grey">
        <div class="image">
          <img :src="employeeData.photo_url" alt />
          <div class="name">{{  employeeData.first_name }} {{ employeeData.last_name }}</div>
          <div>Employee code {{ employeeData.code }}</div>
        </div>
      </div>
      <div class="about">
        <tl-header type="h1">About</tl-header>
        <div class="attribute-value">
          <div>Designation:</div>
          <div class="value">{{ employeeData.designation }}</div>
        </div>
        <div class="attribute-value">
          <div>Job Location:</div>
          <div class="value">{{ employeeData.jobLocation }}</div>
        </div>
        <div class="attribute-value">
          <div>Reporting Manager:</div>
          <div class="value">{{ employeeData.reportingManager }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="profile">
          <tl-header type="h1">Personal Info</tl-header>
          <div class="attribute-value">
            <div>First Name:</div>
            <div class="value">{{ employeeData.first_name }}</div>
          </div>
          <div class="attribute-value">
            <div>Last Name:</div>
            <div class="value">{{ employeeData.last_name }}</div>
          </div>
          <div class="attribute-value">
            <div>DOB:</div>
            <div class="value">{{ employeeData.dob }}</div>
          </div>
          <div class="attribute-value">
            <div>Mobile Number:</div>
            <div class="value">{{ employeeData.mobile_number }}</div>
          </div>
          <div class="attribute-value">
            <div>Email:</div>
            <div class="value">{{ employeeData.email_id }}</div>
          </div>
          <div class="attribute-value">
            <div>Aadhar:</div>
            <div class="value">{{ employeeData.adhar_number }}</div>
          </div>
          <div class="attribute-value">
            <div>PRAN Number:</div>
            <div class="value">{{ employeeData.pran_number }}</div>
          </div>
          <div class="attribute-value">
            <div>PAN Card No.:</div>
            <div class="value">{{ employeeData.pan_number }}</div>
          </div>
          <div class="attribute-value">
            <div>Emergency Contact Name</div>
            <div class="value">{{ employeeData.emergency_contact_name }}</div>
          </div>
          <div class="attribute-value">
            <div>Emergency Contact Number:</div>
            <div class="value">{{ employeeData.emergency_contact_number }}</div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="profile">
          <tl-header type="h1">Address</tl-header>
          <div class="attribute-value">
            <div>Permanent Address:</div>
            <div class="value">{{ permanentAddress }}</div>
          </div>
          <div class="attribute-value">
            <div>Communication Address:</div>
            <div class="value">{{ communicationAddress }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="profile">
          <tl-header type="h1">Payment Details</tl-header>
          <div class="attribute-value">
            <div>Mode of Payment:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].paymentType }}</div>
          </div>
          <div class="attribute-value">
            <div>Bank Name:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].bankName }}</div>
          </div>
          <div class="attribute-value">
            <div>Account Number:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].account_number }}</div>
          </div>
          <div class="attribute-value">
            <div>IFSC:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].ifsc_code }}</div>
          </div>
          <div class="attribute-value">
            <div>Account Type:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].account_type }}</div>
          </div>
          <div class="attribute-value">
            <div>MICR Code:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].micr_code }}</div>
          </div>
          <div class="attribute-value">
            <div>Bank Transfer:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].bank_transfer_type }}</div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="profile">
          <tl-header type="h1">Official Info</tl-header>
          <div class="attribute-value">
            <div>Username:</div>
            <div class="value">{{ employeeData.username }}</div>
          </div>
          <div class="attribute-value">
            <div>Date of Joining:</div>
            <div class="value">{{ employeeData.date_of_joining }}</div>
          </div>
          <div class="attribute-value">
            <div>Official Email Id:</div>
            <div class="value">{{ employeeData.official_email_id }}</div>
          </div>
          <div class="attribute-value">
            <div>Employee Category:</div>
            <div class="value">{{ employeeData.employeeCategory }}</div>
          </div>
          <div class="attribute-value">
            <div>Employee Sub Category:</div>
            <div class="value">{{ employeeData.subcategory }}</div>
          </div>
          <div class="attribute-value">
            <div>Cost Center:</div>
            <div class="value">{{ employeeData.costCenter }}</div>
          </div>
          <div class="attribute-value">
            <div>Grade</div>
            <div class="value">{{ employeeData.grades }}</div>
          </div>
          <div class="attribute-value">
            <div>Band:</div>
            <div class="value">{{ employeeData.band }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="twoColumnGridDashboard marginbottom-5p">
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  props: {},
  components: {},
  data() {
    return {
      breadcrumbList: [
        {
          name: "Home",
          url: `/dashboard/${this.$route.params.entity_index}/employeeProfile`
        },
        {
          name: "Myself",
          url: ``
        }
      ],
      navList: [
        {
          name: "VPF Settings",
          url: ``
        },
      ],
      employeeData: null,
      role: "",
      employee_id: "",
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },

    permanentAddress() {
      if (this.employeeData != null) {
         return `${this.employeeData.permanent_address.addressLineOne == null ? "" : this.employeeData.permanent_address.addressLineOne+","} 
         ${this.employeeData.permanent_address.addressLineTwo == null ? "" : this.employeeData.permanent_address.addressLineTwo+","}
         ${this.employeeData.permanent_address.cityName == null ? "" : this.employeeData.permanent_address.cityName+","} 
         ${this.employeeData.permanent_address.stateName == null ? "" : this.employeeData.permanent_address.stateName} 
         ${this.employeeData.permanent_address.pincode == null ? "" : " - "+this.employeeData.permanent_address.pincode}`;
      }
      return "N/A";
    },

    communicationAddress() {
      if (this.employeeData != null) {
         return `${this.employeeData.communication_address.addressLineOne == null ? "" : this.employeeData.communication_address.addressLineOne+","} 
         ${this.employeeData.communication_address.addressLineTwo == null ? "" : this.employeeData.communication_address.addressLineTwo+","}
         ${this.employeeData.communication_address.cityName == null ? "" : this.employeeData.communication_address.cityName+","} 
         ${this.employeeData.communication_address.stateName == null ? "" : this.employeeData.communication_address.stateName} 
         ${this.employeeData.communication_address.pincode == null ? "" : " - "+this.employeeData.communication_address.pincode}`;
      }
      return "N/A";
    }

  },
  mounted() {
    this.getEmployeeData();
  },
  methods: {
    ...mapActions({
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
      getOrgLeList: "onboard/organization/getOrgLeIdList"
    }),

    async getEmployeeData() {
      try {
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
              ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.employee_id = data.data.user.employee_id;

        let obj = {
          'employee_id': this.employee_id
        };
        let response = await this.act_getProfileData(obj);
        //console.log({response});
        this.employeeData = response.data.payload[0];
        this.employeeData.dob = new Date(this.employeeData.dob).toISOString().slice(0, 10);
        this.employeeData.date_of_joining = new Date(this.employeeData.date_of_joining).toISOString().slice(0, 10);
        // this.postLock();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

     navigateToPf(url){
         this.$router.push({
        path:url
          });
      },

  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins

.profile {
  width: 100%;
  height: auto;
  border: 1px solid #efefef;
  border-radius: 8px;
  box-shadow: 0px 1px 2px #efefef;
  padding: 15px;
  margin-bottom: 30px;
}

.attribute-value {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 6px 5px 0px 5px;
  *:nth-child(2n) {
    font-weight: 600;
  }
}

.image {
  width: 100%;
  background-color: #f4f4f4;
}

.in-row {
  display: flex;
  padding: 15px;
  margin-bottom: 20px;
  .background-grey {
    width: 16.66%;
    background-color: #F4F4F4;
    padding: 15px;
    height: 100%;
    .image {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      img {
        height: 120px;
        width: 120px;
        radius: 50%;
      }
      .name {
        font-size: 16px;
        font-weight: 600;
        color: #444444;
      }
    }
  }
  .about {
    width: 83.33%;
    border: 1px solid #efefef;
    border-radius: 8px;
    box-shadow: 0px 1px 2px #efefef;
    padding: 15px;
  }
}

</style>
